import { render } from "./CGU.vue?vue&type=template&id=0f93d7f0&scoped=true"
const script = {}

import "./CGU.vue?vue&type=style&index=0&id=0f93d7f0&scoped=true&lang=css"

import exportComponent from "/home/sc1nboq9356/staging-meiser/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f93d7f0"]])

export default __exports__